(function ($) {

	let $contact_form = $("form#gp-ajax-form--customer_personal_data")

	// Show/hide shipping inputs
	$contact_form.find("input[name='add_billing_info']").change(toggle_billing_info)

	function toggle_billing_info() {
		$("#form-billing-info").slideToggle(250)
	}

})(jQuery)
